<script>
  import RelatorioLancamentosPagamentos from './RelatorioLancamentosPagamentos.vue';
  import RelatorioRubricasSintetico from '~modulos/relatorio/componentes/Rubricas/Sintetico.vue';
  import transparenciaServico from '../../servico';
  import Carregando from '~componentes/Carregando.vue';

  export default {
    name: 'DetalharProjeto',
    components: { RelatorioLancamentosPagamentos, RelatorioRubricasSintetico, Carregando },
    data() {
      return {
        projeto: {
          idProjeto: null,
          nomeProjeto: null,
          objetivo: null,
          clausulaConfidencialLei8958: null,
          unidade: null,
          departamento: null,
          dataInicioVigencia: null,
          dataTerminoVigencia: null,
          dataInicio: null,
          dataTermino: null,
          volumeTotalRecursos: null,
          nomeCoordenador: null,
          nrProcesso: null,
          nrProcessoInst: null,
          nomeOrgaoFinanciador: null,
          perpetuaClausulaConfidencialLei8958: null,
          arquivosClausulaConfidencialLei8958: null,
          relatoriosClausulaConfidencialLei8958: null,
          dataLimiteClausulaConfidencialLei8958: null,
          adeptoLei13019: null,
          emendaParlamentar: null,
          emendaParlamentarDescricao: null,
        },
        tipoRelatorio: null,
        relatorio: null,
        relatorioAcompanhamentoProjeto: [],
        orgaosFinaciadoresProjeto: [],
        arquivos: [],
        RELATORIO_LANCAMENTOS:  '0',
        RELATORIO_PAGAMENTO_PESSOA_FISICA:  '1',
        RELATORIO_PAGAMENTO_PESSOA_JURIDICA:  '2',
        RELATORIO_PAGAMENTO_AGENTE:  '3',
        RELATORIO_PAGAMENTO_ALUNO:  '4',
        RELATORIO_PAGAMENTO_CLT:  '5',
        RELATORIO_RUBRICAS:  '6',
        RELATORIO_COMPRAS_LICITACOES: '7',
        RELATORIO_ACOMPANHAMENTO_PROJETO: '8',
        configuracao: this.$storage.configuracao(),
        carregando: false,
      }
    },
    methods: {
      carregarProjeto(id) {
        return transparenciaServico
          .informacaoProjeto(id)
          .then(informacaoProjeto => {
            this.projeto = informacaoProjeto;
          });
      },
      carregarOrgaosFinaciadoresProjeto(id) {
        return transparenciaServico
          .orgaosFinaciadoresProjeto(id)
          .then(orgaosFinaciadoresProjeto => {
            this.orgaosFinaciadoresProjeto = orgaosFinaciadoresProjeto;
          });
      },
      carregarRelatorioAcompanhamentoProjeto(id) {
        this.relatorioAcompanhamentoProjeto = [];
        return transparenciaServico.relatorioAcompanhamentoProjeto(id)
          .then(relatorio => {
            this.relatorioAcompanhamentoProjeto = relatorio;
          })
          .catch(() => {
            this.$swal('', 'Ocorreu um erro ao verificar os relatórios disponíveis, tente novamente.', 'error');
          });
      },
      carregarArquivos(id) {
        transparenciaServico
          .arquivos(id)
          .then(arquivos => {
            this.arquivos = arquivos;
          });
      },
      download(arquivo) {
        transparenciaServico
          .download(this.$route.params.id, this.nomeArquivo(arquivo))
          .then(arquivo => {
            arquivo.download();
          });
      },
      formatarParticipacao(valor) {
        const participacao = parseFloat(valor);

        if (!valor || isNaN(participacao)) {
          return '0,00';
        }
        
        return participacao.toFixed(2).replace('.', ',');
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      },
      gerarRelatorioLancamentos() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_LANCAMENTOS } });
      },
      gerarRelatorioRubricas() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_RUBRICAS } });
      },
      gerarRelatorioPagamentoPessoaFisica() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_PAGAMENTO_PESSOA_FISICA } });
      },
      gerarRelatorioPagamentoPessoaJuridica() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_PAGAMENTO_PESSOA_JURIDICA } });
      },
      gerarRelatorioPagamentoAgente() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_PAGAMENTO_AGENTE } });
      },
      gerarRelatorioPagamentoAluno() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_PAGAMENTO_ALUNO } });
      },
      gerarRelatorioPagamentoClt() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query, params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_PAGAMENTO_CLT } });
      },
      gerarRelatorioComprasLicitacoes() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query, params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_COMPRAS_LICITACOES } });
      },
      gerarRelatorioAcompanhamentoProjeto() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query, params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_ACOMPANHAMENTO_PROJETO } });
      },
      verificarClausulaConfidencial() {
        const dataLimite = new Date(this.projeto.dataLimiteClausulaConfidencialLei8958);
        const dataAtual = new Date();

        return this.projeto.perpetuaClausulaConfidencialLei8958
          || (this.projeto.clausulaConfidencialLei8958 && dataLimite.getTime() > dataAtual.getTime());
      },
      voltar() {
        this.$router.push({
          name: 'transparencia.projetos',
          query: this.$route.query
        });
      },
    },
    computed: {
      mostrarAnexosProjeto() {
        const projetoConfidencial = this.verificarClausulaConfidencial();
        if (projetoConfidencial && this.projeto.arquivosClausulaConfidencialLei8958) {
          return false;
        }

        return true;
      },
      mostrarRelatorioAcompanhamentoProjeto() {
        let mostrar = false;

        if (this.relatorioAcompanhamentoProjeto.length > 0) {
          mostrar = true;
        }

        return mostrar;
      },
      mostrarRelatorios() {
        const projetoConfidencial = this.verificarClausulaConfidencial();
        if (projetoConfidencial && this.projeto.relatoriosClausulaConfidencialLei8958) {
          return false;
        }

        if (this.projeto.transpLancamentos || this.projeto.transpPessoaFisica || this.projeto.transpPessoaFisicaCLT ||
          this.projeto.transpPgtoPessoaJuridica || this.projeto.transpAgenteServidorPublico || this.projeto.transpAlunos ||
          this.projeto.transpRubricas || this.projeto.transpComprasLicitacoes || this.mostrarRelatorioAcompanhamentoProjeto)
        {
          return true;
        }

        return false;
      },
      mostrarMensagemProjetoConfidencial() {
        return this.verificarClausulaConfidencial();
      },
      mensagemProjetoConfidencial() {
        let mensagem = 'O projeto está protegido por cláusula contratual de sigilo e confidencialidade. Os relatórios não estarão disponíveis para consulta pública (Lei 8958/1994 - Artigo 4º - Inciso I).';
        if (this.configuracao.mensagemProjetoSigilosoTransparencia) {
          mensagem = this.configuracao.mensagemProjetoSigilosoTransparencia;
        }

        if (this.projeto.dataLimiteClausulaConfidencialLei8958 && !this.projeto.perpetuaClausulaConfidencialLei8958) {
          const dataLimite = new Date(this.projeto.dataLimiteClausulaConfidencialLei8958);
          const dataFormatada = dataLimite.toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          });

          mensagem += `<br/>Data fim do sigilo: ${dataFormatada}`;
        }

        return mensagem;
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Portal da transparência`;
      this.carregando = true;
      this.carregarProjeto(this.$route.params.id);
      this.carregarOrgaosFinaciadoresProjeto(this.$route.params.id);
      this.carregarRelatorioAcompanhamentoProjeto(this.$route.params.id);
      this.carregarArquivos(this.$route.params.id);
      this.carregando = false;
    },
  }
</script>

<template>
  <div>

    <Carregando v-if="carregando"></Carregando>

    <div class="row" v-if="!carregando">
      <div class="col-xs-12">

        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row" v-if="mostrarMensagemProjetoConfidencial">
              <div class="col-xs-12">
                <p class="mensagem-confidencial" v-html="mensagemProjetoConfidencial"></p>
              </div>
            </div>

            <div class="row">
              <dl class="col-md-8">
                <dt>Nome do projeto</dt>
                <dd>{{ projeto.nomeProjeto }}</dd>
              </dl>
              <dl class="col-md-4" style="text-align: right;">
                <dt>Valor do projeto (R$)</dt>
                <dd>{{ projeto.volumeTotalRecursos | formatarNumero }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-md-12">
                <dt>Contratante / Contratada</dt>
                <dd>{{ configuracao.nomeFundacao }} ({{ configuracao.abreviaturaFundacao }}) - CNPJ: {{ configuracao.cnpjFundacao }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-xs-6">
                <dt>Coordenador</dt>
                <dd>{{ projeto.nomeCoordenador || '---' }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Unidade</dt>
                <dd>{{ projeto.unidade || '---' }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Departamento</dt>
                <dd>{{ projeto.departamento || '---' }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-md-3">
                <dt>Período de Execução</dt>
                <dd>{{ projeto.dataInicio | formatarData }} - {{ projeto.dataTermino | formatarData }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Período de Vigência</dt>
                <dd>{{ projeto.dataInicioVigencia | formatarData }} - {{ projeto.dataTerminoVigencia | formatarData }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Nº Convênio/Contrato</dt>
                <dd>{{ projeto.nrProcesso || '---' }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Nº Processo</dt>
                <dd>{{ projeto.nrProcessoInst || '---' }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-md-3">
                <dt>Data de Assinatura</dt>
                <dd v-if="projeto.dataAssinContrato">{{ projeto.dataAssinContrato | formatarData }}</dd>
                <dd v-else>{{ '---' }}</dd>
              </dl>
              <dl class="col-md-6">
                <dt>Adepto à lei 13.019/2024</dt>
                <dd>{{ projeto.adeptoLei13019 ? ' Sim' : 'Não' }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-md-3">
                <dt>Emenda Parlamentar</dt>
                <dd>{{ projeto.emendaParlamentar ? ' Sim' : 'Não' }}</dd>
              </dl>
              <dl class="col-md-6">
                <dt>Descrição da Emenda Parlamentar</dt>
                <dd>{{ projeto.emendaParlamentarDescricao || '---' }}</dd>
              </dl>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <dt>Órgão Financiador</dt>
                <div class="table-responsive margin-top-5">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Orgão</th>
                        <th>Tipo de órgão</th>
                        <th>Esfera</th>
                        <th>Fonte de recurso</th>
                        <th style="text-align: right;">Participação (%)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="orgaoFinanciador in orgaosFinaciadoresProjeto">
                        <td>{{ orgaoFinanciador.NomeOrgaoFinanciador }}</td>
                        <td>{{ orgaoFinanciador.TipoOrgaoNome }}</td>
                        <td>{{ orgaoFinanciador.EsferaOrgaoNome }}</td>
                        <td>{{ orgaoFinanciador.FonteRecursoNome }}</td>
                        <td style="text-align: right;">{{ formatarParticipacao(orgaoFinanciador.Participacao) }}</td>
                      </tr>
                      <tr v-if="orgaosFinaciadoresProjeto.length === 0 && !carregando">
                        <td colspan="5" class="text-center">Nenhum orgão financiador registrado.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row">
              <dl class="col-xs-12">
                <dt>Objetivo</dt>
                <dd class="white-space-pre">{{ projeto.objetivo || '---' }}</dd>
              </dl>
            </div>

            <div v-if="mostrarRelatorios">
              <div style="border-top: 1px solid #ccc; padding-bottom: 12px;" />
              <div class="row" style="padding-bottom: 6px;">
                <h3 class="col-xs-12"><b>Relatórios</b></h3>
              </div>

              <div class="row">

                <div class="col-md-3 col-tela-grande" v-if="projeto.transpLancamentos">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          data-toggle="tooltip" title="Lançamentos"
                          :class="{'active': tipoRelatorio === RELATORIO_LANCAMENTOS}" @click="gerarRelatorioLancamentos"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Lançamentos
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpRubricas">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_RUBRICAS}" @click="gerarRelatorioRubricas"
                          data-toggle="tooltip" title="Rubricas"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Rubricas
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpPessoaFisica">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_PESSOA_FISICA}"
                          data-toggle="tooltip" title="Pagamento Pessoa Física"
                          @click="gerarRelatorioPagamentoPessoaFisica"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Pgto Pessoa Física
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpAgenteServidorPublico">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_AGENTE}"
                          data-toggle="tooltip" title="Pagamento a Agentes e Servidores Públicos"
                          @click="gerarRelatorioPagamentoAgente"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Pgto a Agentes e Servidores Públicos
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpPessoaFisicaCLT">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_CLT}" @click="gerarRelatorioPagamentoClt"
                          data-toggle="tooltip" title="Pagamento Pessoa Física CLT"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Pgto Pessoa Física CLT
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpAlunos">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_ALUNO}"
                          @click="gerarRelatorioPagamentoAluno"
                          data-toggle="tooltip" title="Pagamento Alunos"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Pgto Alunos
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpPgtoPessoaJuridica">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_PESSOA_JURIDICA}"
                          @click="gerarRelatorioPagamentoPessoaJuridica"
                          data-toggle="tooltip" title="Pagamento Pessoa Jurídica"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Pgto Pessoa Jurídica
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpComprasLicitacoes">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_PESSOA_JURIDICA}"
                          @click="gerarRelatorioComprasLicitacoes"
                          data-toggle="tooltip" title="Compras/Licitações"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Compras/Licitações
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="mostrarRelatorioAcompanhamentoProjeto">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_ACOMPANHAMENTO_PROJETO}"
                          @click="gerarRelatorioAcompanhamentoProjeto"
                          data-toggle="tooltip" title="Acompanhamento Projeto"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Acompanhamento Projeto
                  </button>
                </div>
              </div>
            </div>

            <div v-if="mostrarAnexosProjeto">
              <div style="border-top: 1px solid #ccc; padding-bottom: 12px;" />
              <div class="row" style="padding-bottom: 6px;">
                <h3 class="col-xs-12"><b>Anexos do projeto</b></h3>
              </div>

              <div class="row" style="padding-bottom: 6px;">
                <div class="col-xs-12">
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Documento</th>
                          <th>Visualizar/Download</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="arquivo in arquivos">
                          <td>{{ nomeArquivo(arquivo) }}</td>
                          <td class="action">
                            <button type="button"
                                    class="btn btn-default btn-xs"
                                    @click="download(arquivo)">
                              <i class="fa fa-download"></i>
                            </button>
                          </td>
                        </tr>
                        <tr v-if="arquivos.length === 0 && !carregando">
                          <td colspan="2" class="text-center">Nenhum arquivo encontrado.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12 flex-container" style="justify-content:end; margin-bottom:25px">
        <button class="btn btn-primary"
                @click="voltar">
          <i class="fa fa-arrow-left"></i> Voltar
        </button>
      </div>
    </div>
  </div>
</template>
<style>
  .mensagem-confidencial {
    padding: 15px;
    margin-bottom: 10px;
    border: 1px solid transparent;
    border-radius: 4px;
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
    font-weight: bold;
  }

  .botao-relatorio {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (min-width: 1500px) {
    .col-tela-grande {
      width: 20%;
    }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/DetalharProjeto.vue